import { ChurchCenterStatus } from "@planningcenter/tapestry-react"
import ErrorBoundary from "components/error_boundary"
import PropTypes from "prop-types"
import { ModalContextProvider, useModal } from "../modals/Modal"
import ChurchCenterSettingsModal from "./ChurchCenterSettingsModal"

const ChurchCenterSettings = ({
  ccaEnabled,
  ccwEnabled,
  ccaRegistrationsPublished,
  churchCenterDisabledOrUnpublished,
  ccwRegistrationsPublished,
  churchCenterEventsUrl,
  churchCenterEventSort,
  subscribedToPublishing,
  isAdmin,
  isPhoenix
}) => {
  const { onModalOpen } = useModal()

  return (
    <>
      <ChurchCenterSettingsModal
        ccPublishingEnabled={subscribedToPublishing}
        churchCenterEventSort={churchCenterEventSort}
        ccEnabled={
          (ccaEnabled && ccaRegistrationsPublished) || (ccwEnabled && ccwRegistrationsPublished)
        }
      />
      <ErrorBoundary fallback={<noscript /> /* report errors w/o changing existing UI behavior */}>
        <ChurchCenterStatus
          ccAppEnabled={ccaEnabled && ccaRegistrationsPublished}
          ccPublishingEnabled={!churchCenterDisabledOrUnpublished}
          ccWebEnabled={ccwEnabled && ccwRegistrationsPublished}
          productUrl={churchCenterEventsUrl}
          destinationLabel="on Church Center"
          description="On Church Center, people can register and browse signups."
          disabledDescription="People cannot register or browse signups on the web or mobile app."
          dropdownProps={
            isPhoenix
              ? {
                  style: {
                    boxShadow: "inset 0px 0px 0px 1px var(--t-border-color-button-neutral)"
                  },
                  variant: "outline"
                }
              : {
                  theme: "app",
                  variant: "fill"
                }
          }
          buttonProps={{
            onClick: e => {
              if (e.target.textContent === "Update settings") {
                onModalOpen()
              }
            }
          }}
          showSettingsLink={isAdmin}
        />
      </ErrorBoundary>
    </>
  )
}

ChurchCenterSettings.propTypes = {
  ccaEnabled: PropTypes.bool,
  ccwEnabled: PropTypes.bool,
  ccaRegistrationsPublished: PropTypes.bool,
  churchCenterDisabledOrUnpublished: PropTypes.bool,
  ccwRegistrationsPublished: PropTypes.bool,
  churchCenterEventsUrl: PropTypes.string,
  churchCenterEventSort: PropTypes.string,
  subscribedToPublishing: PropTypes.bool,
  isAdmin: PropTypes.bool,
  isPhoenix: PropTypes.bool
}

const ChurchCenterSettingsModalWrapper = props => {
  return (
    <ModalContextProvider>
      <ChurchCenterSettings {...props} />
    </ModalContextProvider>
  )
}

export default ChurchCenterSettingsModalWrapper
